import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import Logo from "../../../assets/Logo-Negro.png";
import "../styles/SancionesForm.css";
import { getMotivosOptions, getMotivoConfig, generarMensajeMotivo } from "../../../config/motivos.config";
import FirmasPad from "../../../components/FirmasPad";

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

// Helper para obtener headers de auth
const getAuthHeaders = () => {
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  return {
    'x-user-id': String(user?.id || user?.Legajo || user?.CdEmpleado || '1'),
    'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
  };
};

const InformeForm = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  
  const obtenerNombreInspector = () => {
    const inspector = JSON.parse(localStorage.getItem("user"));
    return inspector?.Nombre || "Inspector No Identificado";
  };

  // Obtener fecha y hora actual en formato YYYY-MM-DD y HH:MM
  const obtenerFechaActual = () => {
    const now = new Date();
    return now.toISOString().split('T')[0];
  };

  const obtenerHoraActual = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  };

  const [formData, setFormData] = useState({
    informeNumero: "",
    lugarControl: "",
    lugarAbandono: "",
    fecha: obtenerFechaActual(),
    hora: obtenerHoraActual(),
    actuante: obtenerNombreInspector(),
    motivo: "",
    motivoDetalle: "",
    empleado: "",
    legajo: "",
    nroCoche: "",
    linea: "",
    horaPresentacion: "",
    servicio: "",
    rutaRecorrido: "",
    rutaFueraRecorrido: "",
    velocidad: "",
    fallaMecanica: "",
    fechaCM: "",
    fechaDenuncia: "",
    fechaSiniestro: "",
    horaSiniestro: "",
    lugarSiniestro: "",
    marcaVehiculo: "",
    dominioVehiculo: "",
    msgRoturas: "",
    textoInforme: "",
    lugarPresentacion: "",
    // Nuevos campos corregidos
    horarioPasoTeorico: "",
    tomaServicio: "",
    detalleVestimenta: "",
    horaFin: "",
    horaLlegada: "",
    horaSalidaProgramada: "",
    horaSalidaReal: "",
    lugarAscenso: "",
    horaAscenso: "",
    zonaHojaRuta: "",
    horaHojaRuta: ""
  });

  // Estados para imagen y firma
  const [imagenBase64, setImagenBase64] = useState(null);
  const [firmaBase64, setFirmaBase64] = useState(null);
  const [mostrarModalFirma, setMostrarModalFirma] = useState(false);
  const [imagenPreview, setImagenPreview] = useState(null);
  const fileInputRef = useRef(null);

  // Generar mensaje automáticamente con useMemo
  const mensajeGenerado = useMemo(() => {
    if (!formData.motivo) return '';
    return generarMensajeMotivo(formData.motivo, formData);
  }, [formData]);

  // Obtener configuración del motivo actual
  const motivoConfig = useMemo(() => {
    if (!formData.motivo) return null;
    return getMotivoConfig(formData.motivo);
  }, [formData.motivo]);

  // Función para obtener el siguiente número de informe
  const fetchNumeroInforme = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/informes/ultimo-numero`, {
        headers: getAuthHeaders()
      });
      setFormData((prev) => ({ ...prev, informeNumero: data.siguiente }));
    } catch (error) {
      console.error("❌ Error al obtener número de informe:", error);
    }
  };

  useEffect(() => {
    fetchNumeroInforme();
  }, []);


  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "legajo" && value) {
      try {
        const { data } = await axios.get(`${API_URL}/api/empleados/${value}`, {
          headers: getAuthHeaders()
        });
        setFormData((prev) => ({ ...prev, empleado: data.nombre }));
      } catch (error) {
        console.error("❌ Error al obtener nombre del empleado:", error);
        setFormData((prev) => ({ ...prev, empleado: "" }));
      }
    }
  };

  const handleMotivoChange = (e) => {
    const motivo = e.target.value;
    setFormData((prev) => ({ ...prev, motivo, motivoDetalle: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validar que tenga firma
    if (!firmaBase64) {
      alert("⚠️ Debes firmar el informe antes de guardarlo");
      return;
    }

    // Validar que motivo "Otros" tenga texto manual
    if (formData.motivo === 'Otros' && !formData.motivoDetalle?.trim()) {
      alert("⚠️ El motivo 'Otros' requiere que escribas un mensaje personalizado");
      return;
    }
    
    setMostrarModalFirma(false);
    guardarInforme();
  };

  const guardarInforme = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      // Determinar el mensaje final (manual o autogenerado)
      const mensajeFinal = motivoConfig?.allowManualMessage && formData.motivoDetalle 
        ? formData.motivoDetalle 
        : mensajeGenerado;

      // Guardar el informe y los archivos en un solo paso
      const payload = {
        NroInforme: formData.informeNumero,
        FechaRealizado: formData.fecha,
        Hora: formData.hora,
        Motivo: formData.motivo,
        MotivoDetalle: mensajeFinal,
        LegajoEmp: formData.legajo,
        NombreEmp: formData.empleado,
        Servicio: formData.servicio,
        Linea: formData.linea,
        CocheInterno: formData.nroCoche,
        Estado: "pendiente",
        RealizadoPor: user?.Legajo,
        FirmaInspector: firmaBase64 || null,
        ImagenAdjunta: imagenBase64 || null
      };

      await axios.post(`${API_URL}/api/informes`, payload, {
        headers: getAuthHeaders()
      });

      alert("✅ Informe guardado en la base de datos");
      
      // Limpiar formulario y obtener siguiente número
      limpiarFormulario();
    } catch (error) {
      console.error("❌ Error al guardar informe:", error);
      alert("No se pudo guardar el informe");
    }
  };

  const limpiarFormulario = async () => {
    // Obtener el siguiente número de informe antes de limpiar
    await fetchNumeroInforme();
    // ...aquí va el resto del código de limpieza del formulario si lo necesitas...
    setMostrarModalFirma(false);
  };

  // Handler para campos extra dinámicos
  const renderCamposExtra = () => {
    if (!motivoConfig) return null;
    
    return motivoConfig.fields.map((campo) => {
      // Etiquetas legibles para los campos
      const labels = {
        horaPresentacion: "Hora de Presentación",
        lugarAbandono: "Lugar de Abandono",
        horarioPasoTeorico: "Horario Paso Teórico",
        servicio: "Servicio",
        rutaRecorrido: "Ruta de Recorrido",
        rutaFueraRecorrido: "Ruta Fuera de Recorrido",
        velocidad: "Velocidad (km/h)",
        fallaMecanica: "Falla Mecánica / Daños",
        fechaCM: "Fecha Control Médico",
        fechaDenuncia: "Fecha de Denuncia",
        fechaSiniestro: "Fecha del Siniestro",
        horaSiniestro: "Hora del Siniestro",
        lugarSiniestro: "Lugar del Siniestro",
        marcaVehiculo: "Marca del Vehículo",
        dominioVehiculo: "Dominio del Vehículo",
        msgRoturas: "Roturas",
        detalleVestimenta: "Detalle de Falta de Vestimenta",
        lugarPresentacion: "Lugar de Presentación",
        tomaServicio: "¿Se le permite tomar servicio?",
        horaFin: "Horario Programado de Llegada",
        horaLlegada: "Horario Real de Llegada",
        horaSalidaProgramada: "Horario Programado de Salida",
        horaSalidaReal: "Horario Real de Salida",
        lugarAscenso: "Lugar de Ascenso",
        horaAscenso: "Hora de Ascenso",
        zonaHojaRuta: "Zona de Hoja de Ruta",
        horaHojaRuta: "Hora de Hoja de Ruta"
      };

      const inputType = campo.startsWith('fecha') ? 'date' : 
                       campo.startsWith('hora') ? 'time' : 'text';

      return (
        <div key={campo}>
          <label>{labels[campo] || campo}</label>
          {campo === 'detalleVestimenta' && motivoConfig.allowManualMessage ? (
            <textarea
              name={campo}
              value={formData[campo] || ""}
              onChange={handleChange}
              rows={3}
              placeholder="Describa la falta de vestimenta..."
            />
          ) : campo === 'tomaServicio' ? (
            <select
              name={campo}
              value={formData[campo] || ""}
              onChange={handleChange}
            >
              <option value="">¿Se le permite tomar servicio?</option>
              <option value="si">Sí</option>
              <option value="no">No</option>
            </select>
          ) : (
            <input
              type={inputType}
              name={campo}
              value={formData[campo] || ""}
              onChange={handleChange}
            />
          )}
        </div>
      );
    });
  };

  // Handler para eliminar imagen
  const eliminarImagen = () => {
    setImagenBase64(null);
    setImagenPreview(null);
  };

  // Handler para subir archivo
  const handleSubirArchivo = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new window.FileReader();
    reader.onloadend = () => {
      setImagenBase64(reader.result);
      setImagenPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  // Handler para abrir modal de firma
  const abrirModalFirma = () => {
    setMostrarModalFirma(true);
  };

  // Handlers para firma
  const handleCancelarFirma = () => {
    setMostrarModalFirma(false);
  };

  const handleGuardarFirma = (firma) => {
    setFirmaBase64(firma);
    setMostrarModalFirma(false);
  };

  return (
    <form className="informe-form" onSubmit={handleSubmit}>
      <img src={Logo} className="logoInforme" alt="Logo" />
      <h2>Informe de Servicio</h2>

      <div className="form-grid">
        <div>
          <label>Informe N°</label>
          <input
            type="text"
            name="informeNumero"
            value={formData.informeNumero}
            readOnly
          />
        </div>
        <div>
          <label>Lugar de Control</label>
          <input
            type="text"
            name="lugarControl"
            value={formData.lugarControl}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Fecha</label>
          <input
            type="date"
            name="fecha"
            value={formData.fecha}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Hora</label>
          <input
            type="time"
            name="hora"
            value={formData.hora}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Actuante</label>
          <input
            type="text"
            name="actuante"
            value={user.Legajo}
            onChange={handleChange}
            placeholder="Se auto-completa con el inspector"
          />
        </div>
        <div>
          <label>Motivo</label>
          <select
            name="motivo"
            value={formData.motivo}
            onChange={handleMotivoChange}
          >
            <option value="">Seleccione un motivo</option>
            {getMotivosOptions().map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>Legajo N°</label>
          <input
            type="text"
            name="legajo"
            value={formData.legajo}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Usuario</label>
          <input
            type="text"
            name="empleado"
            value={formData.empleado}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>N° de Coche</label>
          <input
            type="text"
            name="nroCoche"
            value={formData.nroCoche}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Línea</label>
          <input
            type="text"
            name="linea"
            value={formData.linea}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Servicio</label>
          <input
            type="text"
            name="servicio"
            value={formData.servicio}
            onChange={handleChange}
          />
        </div>


        {/* Campos dinámicos */}
        {renderCamposExtra()}
      </div>

      {/* Campo de detalle del motivo */}
      {formData.motivo && (
        <div className="full-width">
          <label>
            {motivoConfig?.allowManualMessage ? 'Mensaje (Editable)' : 'Mensaje generado'}
          </label>
          <textarea
            name="motivoDetalle"
            value={motivoConfig?.allowManualMessage ? formData.motivoDetalle : mensajeGenerado}
            onChange={motivoConfig?.allowManualMessage ? handleChange : undefined}
            rows={4}
            readOnly={!motivoConfig?.allowManualMessage}
            className={motivoConfig?.allowManualMessage ? "" : "campo-auto-generado"}
            placeholder={motivoConfig?.allowManualMessage ? "Escriba el mensaje del informe..." : ""}
          />
          <small className="texto-ayuda">
            {motivoConfig?.allowManualMessage 
              ? 'Complete el mensaje del informe manualmente' 
              : 'Este mensaje se genera automáticamente según los datos ingresados'}
          </small>
        </div>
      )}

      {/* Sección de Imagen Adjunta (Opcional) */}
      <div className="full-width imagen-section">
        <label>Imagen Adjunta (Opcional)</label>
        <div className="imagen-controls">
          <Button 
            variant="secondary" 
            onClick={() => fileInputRef.current?.click()}
            className="btn-imagen"
          >
            📁 Subir Imagen desde Dispositivo
          </Button>
          {imagenPreview && (
            <Button 
              variant="danger" 
              onClick={eliminarImagen}
              className="btn-imagen"
            >
              🗑️ Eliminar Imagen
            </Button>
          )}
        </div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleSubirArchivo}
        />
        {imagenPreview && (
          <div className="imagen-preview">
            <img src={imagenPreview} alt="Preview" style={{ maxWidth: "300px", marginTop: "10px" }} />
          </div>
        )}
      </div>

      {/* Botón para firmar y guardar */}
      <div className="botones-accion">
        {firmaBase64 ? (
          <>
            <div className="firma-confirmada">
              ✅ Informe firmado
              <img src={firmaBase64} alt="Firma" style={{ maxWidth: "200px", marginLeft: "15px", border: "1px solid #ccc" }} />
            </div>
            <button type="button" onClick={handleSubmit} className="pdf-button">
              💾 Guardar Informe
            </button>
          </>
        ) : (
          <button type="button" onClick={abrirModalFirma} className="pdf-button">
            ✍️ Firmar y Guardar Informe
          </button>
        )}
      </div>
      
      {/* Modal de Firma */}
      <Modal show={mostrarModalFirma} onHide={handleCancelarFirma} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Firmar Informe</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">Por favor, firme el informe para continuar:</p>
          <FirmasPad 
            onFirmar={handleGuardarFirma}
            onCancelar={handleCancelarFirma}
            fileName={`informe_${formData.informeNumero}`}
          />
        </Modal.Body>
      </Modal>
    </form>
  );
};

export default InformeForm;
